// src/config/env.ts
// note apiKey isn't really a secure API key; mainly a "soft" protection against direct API access... it's EASILY circumvented
export const env = {
    auth: {
      authority: import.meta.env.VITE_AUTH_AUTHORITY || "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_FHXA3QWlg",
      clientId: import.meta.env.VITE_AUTH_CLIENT_ID || "3thrjhggo6b2jqs9jgbccv4aig",
      redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || "https://app.savingwithdana.com/callback",
      logoutUri: import.meta.env.VITE_AUTH_LOGOUT_URI || "https://app.savingwithdana.com/logout",
      cognitoDomain: import.meta.env.VITE_AUTH_COGNITO_DOMAIN || "https://auth.savingwithdana.com",
      responseType: "code",
      scope: "email openid profile",
    },
    api: {
      baseUrl: import.meta.env.VITE_API_BASE_URL || "https://api.savingwithdana.com",
      apiKey: import.meta.env.VITE_API_KEY || "DUMMY",
    },
  };
